import React, { useEffect, useState } from 'react';
import WorkingHours from 'components/working-hours';
import { BrandWorkingHoursType, WorkingHoursType } from 'utils/types';
import useBrandContext from 'contexts/brand.context';
import moment from 'moment';
import { formatTimeToApiFormat, getWorkingHoursComponentFormatFromApi } from 'utils/functions';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { SuccessModal } from 'components/base/success-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import SingleBottomNav from 'components/base/single-bottom-nav';

const EditBrandOpeningTime = () => {
  const { activeBrand, createBrandForm, setCreateBrandForm } = useBrandContext();
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const workingHoursFormat = createBrandForm.working_hours?.map((item: any) => {
    return {
      name: item.name,
      opening_time: moment(item.opening_time, 'HH:mm:ss').toDate(),
      closing_time: moment(item.closing_time, 'HH:mm:ss').toDate(),
      active: item.active
    };
  });

  const [workingHours, setWorkingHours] = useState<WorkingHoursType[]>(
    getWorkingHoursComponentFormatFromApi(workingHoursFormat)
  );

  useEffect(() => {
    const updatedBrandWorkingHours = createBrandForm.working_hours?.map(
      (brandHour: BrandWorkingHoursType) => {
        const matchingWorkHour = workingHours.find(
          (workHour: WorkingHoursType) => workHour.name === brandHour.name
        );
        if (matchingWorkHour) {
          return {
            ...brandHour,
            opening_time: formatTimeToApiFormat(matchingWorkHour.opening_time),
            closing_time: formatTimeToApiFormat(matchingWorkHour.closing_time),
            active: matchingWorkHour.active
          };
        }

        return brandHour;
      }
    );

    setCreateBrandForm({ ...createBrandForm, working_hours: updatedBrandWorkingHours });
  }, [workingHours]);
  const updateBrandWorkingHours = async () => {
    setLoading(true);

    const payload = {
      days: createBrandForm?.working_hours?.map((item: any) => {
        return {
          brand_id: activeBrand?.id,
          name: item.name.toLowerCase(),
          opening_time: item.opening_time,
          closing_time: item.closing_time,
          active: item.active
        };
      })
    };
    try {
      const res = await apiService.post('marketing/brand/working-hours', { data: payload });
      if (res?.data) {
        setShowSuccess(true);
      }
    } catch {
      toast(
        <ToastMessage type='error' message='There was a problem updating brand working hour' />
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <WorkingHours data={workingHours} setData={setWorkingHours} />

      <SingleBottomNav loading={loading} onConfirm={updateBrandWorkingHours} />
      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Brand working hours updated successfully
      </SuccessModal>
    </div>
  );
};

export default EditBrandOpeningTime;
